import React, { type PropsWithChildren } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import Button from '@atlaskit/button/standard-button';
import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { convertISODateFormat } from '@atlassian/jira-compatibility';
import { ff } from '@atlassian/jira-feature-flagging';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
// eslint-disable-next-line jira/restricted/@atlassian+jira-intl
import { injectIntlV2 as injectIntl, FormattedDate, useIntl } from '@atlassian/jira-intl';
import { AsyncProfileCardNext } from '@atlassian/jira-profilecard-next/src/async';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller';
import messages from './messages';
import type { Props } from './types';

const DateAndUser = (props: Props) => {
	const {
		intl: { formatMessage: formatMessageOld },
		date,
		user: { accountId, displayName },
	} = props;

	const { formatMessage: formatMessageNew } = useIntl();

	const formatMessage = ff('hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3')
		? formatMessageNew
		: formatMessageOld;

	return (
		<Wrapper>
			<FormattedDate
				value={convertISODateFormat(date)}
				year="numeric"
				month="short"
				day="2-digit"
			/>
			<Separator>{formatMessage(messages.byKeyword)}</Separator>
			<DisplayNameWrapper>
				<AsyncProfileCardNext
					accountId={accountId}
					TenantContextSubscriber={TenantContextSubscriber}
				>
					<Button appearance="link" spacing="none">
						{displayName}
					</Button>
				</AsyncProfileCardNext>
			</DisplayNameWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line jira/js/no-inject-intl-if-functional-component
export default injectIntl(DateAndUser);

const WrapperNew = ({ children }: PropsWithChildren<{}>) => <Box>{children}</Box>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WrapperOld = styled.div<any>({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& span': {
		whiteSpace: 'nowrap',
	},
});

const Wrapper = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	WrapperOld,
	WrapperNew,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Separator = styled2.span({
	margin: `0 ${token('space.050', '4px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisplayNameWrapper = styled2.div({
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});
